import { CANONICAL_ORIGIN } from "./canonical-origin.cjs"

export const ENV = {
  BASE_URL: process.env.GATSBY_TTF_BASE_URL,
  API_BASE: process.env.GATSBY_TTF_PUBLIC_API_BASE,
  X_SOURCE_ORIGIN: process.env.GATSBY_TTF_PUBLIC_X_SOURCE_ORIGIN,
  CF_CLIENT_ID: process.env.GATSBY_TTF_CF_CLIENT_ID,
  CF_SECRET: process.env.GATSBY_TTF_CF_SECRET,
  CLIENT_ID: process.env.GATSBY_TTF_CLIENT_ID,
  CLIENT_SECRET: process.env.GATSBY_TTF_CLIENT_SECRET,
  BRAND_SLUG: process.env.GATSBY_TTF_BRAND_SLUG,
  SITE_URL: process.env.GATSBY_TTF_SITE_URL || "https://clickpass.mx",
  // Defined in ./canonical-origin.cjs so the build-time configs share it.
  CANONICAL_ORIGIN,
  STRIPE_PUBLISHABLE_KEY: process.env.GATSBY_TTF_STRIPE_PUBLISHABLE_KEY,
  TTF_ACCESS: process.env.GATSBY_TTF_ACCESS || "manatickets",
  HELP_EMAIL: process.env.GATSBY_TTF_HELP_EMAIL || "support@ticketfairy.com",
  AUTH_PROVIDER: process.env.GATSBY_TTF_AUTH_PROVIDER || "TTF",
  MANA_ENVIRONMENT: process.env.GATSBY_MANA_ENVIRONMENT,
  MANA_TTF_SSO_CLIENT: process.env.GATSBY_MANA_TTF_SSO_CLIENT,
  MANA_TTF_SSO_SECRET: process.env.GATSBY_MANA_TTF_SSO_SECRET,
  MANA_SECRET: process.env.GATSBY_MANA_SECRET,
  MANA_CLIENT: process.env.GATSBY_MANA_CLIENT,
  APP_ID: process.env.GATSBY_TTF_APP_ID,
  // Sent to the API as `?client=` on every event request. The backend must have
  // this identifier registered (3RD_PARTY config + ALLOWED_ORIGINS for
  // clickpass.mx) or event lookups will fail — see the TFS-414 precedent where
  // an unregistered source broke a white-label storefront.
  // NOTE: was previously the constant `"tfsport" || process.env...`, which meant
  // the env var could never take effect; it is now genuinely env-driven.
  CLIENT_NAME: process.env.GATSBY_TTF_CLIENT_NAME || "clickpass",
  FEES_STYLE: process.env.GATSBY_TTF_FEES_STYLE || "FINAL_WITH_BREAKDOWN"
}
